import { useLang } from "@/i18n/LanguageContext";
import type { BlockEditorProps } from "./types";

function detectProvider(url: string): string {
  const u = url.toLowerCase();
  if (u.includes("youtube.com") || u.includes("youtu.be")) return "YouTube";
  if (u.includes("vimeo.com")) return "Vimeo";
  return url ? "MP4 / direct" : "";
}

export function VideoEditor({ content, onChange }: BlockEditorProps) {
  const { t } = useLang();
  const url = content.url ?? "";
  const provider = detectProvider(url);

  return (
    <div>
      <div className="field">
        <label htmlFor="vid-url">{t("Video-URL", "Video URL")}</label>
        <input id="vid-url" value={url} onChange={(e) => onChange({ ...content, url: e.target.value })} placeholder="https://youtu.be/… · https://vimeo.com/… · https://…/clip.mp4" />
        {provider && <span style={{ fontSize: 12.5, color: "var(--grey-text)", marginTop: 6, fontFamily: "var(--mono)" }}>{t("Herkend als", "Detected as")}: {provider}</span>}
      </div>
      <div className="field" style={{ marginBottom: 0 }}>
        <label htmlFor="vid-cap">{t("Bijschrift (optioneel)", "Caption (optional)")}</label>
        <input id="vid-cap" value={content.caption ?? ""} onChange={(e) => onChange({ ...content, caption: e.target.value })} />
      </div>
    </div>
  );
}
